var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table4"},[_c('div',{staticClass:"table-inner"},[_c('table',_vm._l((_vm.tableList),function(table){return _c('tr',{key:table.id},[_c('th',[_c('div',[_vm._v(_vm._s(table.th))])]),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(table.td)}})])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }